import { Card } from "@portal/BaseComponents/Card/AntCard";
import { Style } from "@portal/lib/style/style";

export const ProfileCards = Style(Card, {
  boxShadow: "var(--shadow-1) var(--shadow-1)",
  minWidth: "520px",
  maxWidth: "600px",
  padding: "var(--space-16)",

  ".ant-card-head": {
    padding: 0,
    borderColor: "var(--gray-7)",
    display: "block",
    minHeight: "auto",

    ".ant-card-head-title": {
      marginBottom: "var(--space-8)",
    },
  },
  ".ant-card-body": {
    padding: 0,
  },
  ".ant-card-actions": {
    border: 0,
    height: "40px",
    marginBottom: "-6px",
    marginTop: "6px",

    li: {
      display: "flex",
      margin: 0,
      alignItems: "center",
    },
  },

  variants: {
    layout_margin: {
      m1: {
        ".ant-card-body": {
          marginTop: "1px",
        },
      },
      m2: {
        ".ant-card-body": {
          marginTop: "var(--space-16) ",
        },
      },
    },
  },
  defaultVariants: {
    layout_margin: "m2",
  },
});
